import { withQuery } from 'ufo'
import { firstValue, firstValues } from 'refresh-common'

export default defineNuxtRouteMiddleware(to => {
  // Only apply this middleware to thank-you pages
  const firstSegment = to.path.split('/')[1]
  if (firstSegment !== 'tack' && firstSegment !== 'thank-you' && firstSegment !== 'gracias') {
    return
  }

  const config = useRuntimeConfig()

  // Map locale to correct thank-you page path
  const localePageMap: Record<string, string> = {
    sv: '/tack',
    en: '/thank-you',
    uk: '/thank-you',
    es: '/gracias',
  }

  // A duplicated `lang` is an array here, and it keys `localePageMap`: `['es','en']` would
  // stringify to 'es,en', match nothing, and skip the redirect entirely. An unknown locale
  // does the same, so fall back to the site's own rather than trusting any non-empty string —
  // the map is the whitelist, which keeps the two from drifting apart.
  const queryLang = firstValue(to.query.lang)
  const siteLang: string =
    typeof queryLang === 'string' && localePageMap[queryLang] ? queryLang : config.public.SITE_LANG

  // Carry the incoming params to the redirect target, one value per key. `withQuery`
  // omits the `?` when there is nothing to carry.
  const redirect = (path: string) =>
    navigateTo(withQuery(path, firstValues(to.query)), { redirectCode: 301 })

  // Get the correct path for the current site language
  const correctPath = localePageMap[siteLang]

  // If we're on the wrong thank-you page for this site language, redirect
  if (correctPath && to.path !== correctPath) {
    return redirect(correctPath)
  }

  // Special handling for Spanish since it shares domain with English
  // If we're on the shared domain and trying to access Spanish content
  if (queryLang === 'es' && to.path !== '/gracias') {
    return redirect('/gracias')
  }

  // Handle case where Spanish site is accessed directly without lang parameter
  // This happens when the Spanish site has SITE_LANG=es but someone accesses /thank-you
  if (siteLang === 'es' && to.path === '/thank-you') {
    return redirect('/gracias')
  }
})
